import React from 'react';
import { Link } from 'react-router-dom';

const NdaNetherlandsCta = () => (
  <section className="bg-gradient-to-br from-[#2F4E6F] to-[#1e3550] rounded-2xl p-10 text-center text-white mb-12">
    <h2 className="text-2xl font-bold mb-4">Klaar om jouw NDA te genereren als ZZP'er?</h2>
    <p className="text-blue-100 mb-8 max-w-xl mx-auto">
      Maak in minder dan 2 minuten een professionele geheimhoudingsverklaring op maat voor jouw freelance opdracht in Nederland. Volledig gratis, juridisch correct naar Nederlands recht.
    </p>
    <Link
      to="/contract-generator"
      className="inline-block bg-[#FF8C00] hover:bg-[#e07b00] text-white font-semibold px-10 py-4 rounded-lg text-lg transition-colors duration-200 shadow-lg"
    >
      Genereer jouw contract gratis
    </Link>
  </section>
);

export default NdaNetherlandsCta;
